import { Component, OnInit } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Router } from '@angular/router';
import { WindowRef } from '../../services/windowRef.service';


declare var Razorpay: any;

@Component({
  selector: 'app-selectedplan',
  templateUrl: './selectedplan.component.html',
  styleUrls: ['./selectedplan.component.css']
})
export class SelectedplanComponent implements OnInit {

  pid:string='';
  plan:any;
  uid:string='';
  email:string='';
  payid:'string';
  amount:number=0;

  constructor(private fs:FirebaseService, private router:Router, private winRef:WindowRef) {
    if(localStorage.getItem('pid')){
      this.pid=localStorage.getItem('pid');
      this.fs.getPlan(this.pid).subscribe(res => {
        this.plan=res.payload.data();
        this.amount=this.plan.price * 100;
      });
    }
    let user = JSON.parse( localStorage.getItem('user') );
    if(user){
      this.uid=user.uid;
      this.email=user.email;
    }
   }

  ngOnInit(): void {
  }

  goCheckout(){
    this.fs.newOrder(this.uid, this.pid, this.plan.price, this.payid);
    this.router.navigateByUrl('orders');
  }
  
  payWithRazor(){ 
    let options:any = {
        "key": "rzp_test_HVQeC5dlHrNGFt",
        "amount": this.amount,
        "name": "Purenet Broadband",
        "description": this.plan.pname,
        "image": "../../../assets/p2.png",
        // "handler": function (response){
        //   alert(response.razorpay_payment_id);
        //   this.payid=response.razorpay_payment_id;
        //   this.fs.newOrder(this.uid, this.pid, this.plan.price, this.payid);
        //   this.router.navigateByUrl('orders');
        //  },

        "prefill": {
          "email": this.email
        },
        "theme": {
          "color": "#F66806"
        }
      };

      // let options2 = {
      //   amount: 100,  // amount in the smallest currency unit
      //   currency: "INR",
      //   receipt: "order_rcptid_11",
      //   payment_capture: '1'
      // };

      options.handler = ((response) => {
          // alert(response.razorpay_payment_id);
          this.payid=response.razorpay_payment_id;
          this.goCheckout();
      });
      
      // options.modal.ondismiss = (() => {
      //   console.log("payment cancelled");
      // });

      let rzp1 = new this.winRef.nativeWindow.Razorpay(options);
      rzp1.open();
  }
  

  goCancel(){
    this.router.navigateByUrl('');
  }

}
